module.exports = __webpack_public_path__ + "media/images/icon-sales-e92682b9e0d64e8f03a21d8e84bbfde1.svg";